import { IPulseRecordPayload } from "./IPulseRecordPayload";

export enum PulseMessageConsoleDisplayType {
    Record,
    Response
}

export interface IPulseMessage {
    Id: string;

    //----

    consoleDisplayType: PulseMessageConsoleDisplayType;
}

export interface IPulseRecord extends IPulseMessage {

    Payload: string;
    VehicleId?: number;
    Serial: string;
    UpdatedTime: Date;
    CreatedTime: Date;
    ResponseType: CameraCommandType

    //--

    parsedPayload?: IPulseRecordPayload;
}

export interface IPulseResponse extends IPulseMessage {
    CommandJson: string;
    CameraCommandType: CameraCommandType;
    PulseRecordId: number;
}

export enum CameraCommandType {
    None = 0,
    RequestLog = 1,
    ConfigUpdate = 2,
    AppUpdate = 4,
    SendCommand = 8,
    RequestVideo = 0x10
}

export interface IPulseRecordQueryOptions {
    Id?: string;
    Serial?: string;
    VehicleId?: number;
    Start?: Date;
    End?: Date;
}

export interface ILatestPulseRecordQueryOptions {
    Serial?: string;
    VehicleId?: number;
}
